import { smartHomeInit } from '../../../snippets/smart-home/smart-home';

window.onReady(() => {
  // NOTE: load Need for caret
  window.$(window).load(() => {
    smartHomeInit('sf-h/b-exp-smart-home');
  });
});
